import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "latitude", "longitude"]

  connect() {
    this.updateButtonText()
  }

  updateButtonText() {
    console.log("Updating button text...");
    if (!navigator.permissions) {
      this.buttonTarget.textContent = "AUTORISER";
      return;
    }
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
        console.log(result.state);
      if (result.state === "granted") {
        this.buttonTarget.textContent = "Démarrer la visite";
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitudeTarget.value = position.coords.latitude;
            this.longitudeTarget.value = position.coords.longitude;
          },
          () => {}
        );
      } else if (result.state === "prompt") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.buttonTarget.textContent = "Démarrer la visite";
            this.latitudeTarget.value = position.coords.latitude;
            this.longitudeTarget.value = position.coords.longitude;
            this.dispatch("shared", { detail: { content: true } })
          },
          () => {
            this.buttonTarget.textContent = "Autoriser la géolocalisation dans les paramètres du navigateur";
          }
        );
      } else if (result.state === "denied") {
        this.buttonTarget.textContent = "Autoriser la géolocalisation dans les paramètres du navigateur";
      }
      result.onchange = () => this.updateButtonText();
    });
  }

  // function to request location on button click then redirect if granted
  requestLocation(event) {
    event.preventDefault();
    if (!navigator.geolocation) {
      alert("La géolocalisation n'est pas prise en charge par votre navigateur.");
      return;
    }
    this.buttonTarget.textContent = "Chargement...";
    this.buttonTarget.disabled = true;
    this.buttonTarget.setAttribute("aria-busy", "true");
    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latitudeTarget.value = position.coords.latitude;
        this.longitudeTarget.value = position.coords.longitude;
        // Redirection vers la page de démarrage de la visite
        window.location.href = "/itineraries/new?lat=" + position.coords.latitude + "&lng=" + position.coords.longitude;
      },
      (error) => {
        this.buttonTarget.disabled = false;
        this.buttonTarget.removeAttribute("aria-busy");
        if (error.code === error.PERMISSION_DENIED) {
          this.buttonTarget.textContent = "Autoriser la géolocalisation dans les paramètres du navigateur";
        } else if (error.code === error.TIMEOUT) {
          this.buttonTarget.textContent = "Temps de réponse dépassé — réessayer";
        } else {
          this.buttonTarget.textContent = "Erreur lors de l'accès à la localisation";
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }
}
